import { useTheme } from "@mui/system";

export default function MyAppointments({ size = 20 }) {
  const theme = useTheme();

  const baseWidth = 20;
  const baseHeight = 20;

  const height = (baseHeight * size) / baseWidth;
  return (
    <svg 
      width={baseWidth}
      height={height} 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M9 19C13.9706 19 18 14.9706 18 10C18 5.02943 13.9706 1 9 1C4.02943 1 0 5.02943 0 10C0 14.9706 4.02943 19 9 19ZM7.875 4.375V10.466L11.5795 14.1705L13.1705 12.5795L10.125 9.53401V4.375H7.875Z" 
        fill={theme.palette.rgd.primary}
      />
    </svg>
  )
}